module.exports = __webpack_public_path__ + "media/new_order.17fb5999.mp3";